import { render, staticRenderFns } from "./ModalSimilarLaptops.vue?vue&type=template&id=8e7c0590&"
import script from "./ModalSimilarLaptops.vue?vue&type=script&lang=js&"
export * from "./ModalSimilarLaptops.vue?vue&type=script&lang=js&"
import style0 from "./ModalSimilarLaptops.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports